(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/utils.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/utils.js');

const { BILLING } = svs.ticket_partner.companyDetails.constants.ADDRESS_TYPES;
const { HEADER: BILLING_HEADER } = svs.ticket_partner.companyDetails.constants.TEXTS.BILLING_ADDRESS;
const { HEADER: DELIVERY } = svs.ticket_partner.companyDetails.constants.TEXTS.DELIVERY_ADDRESS;
const { HEADER: LEGAL } = svs.ticket_partner.companyDetails.constants.TEXTS.COMPANY_ADDRESS_LEGAL;
const createUpdateCompanyCustomerRequest = (state) => {
  const { addresses } = state.companyDetails;
  const companyDetailsReq = { ...state.companyDetails,
    addresses: state.companyDetails.addresses.map((address) => ({ ...address, zip: address.zip?.replaceAll(' ', '') })),
    phone: state.companyDetails.phone?.replaceAll(' ', ''),
    cellPhone: state.companyDetails.cellPhone?.replaceAll(' ', '') };
  delete companyDetailsReq.edit;
  return { ...companyDetailsReq, billing: addresses.find(({ addressType }) => addressType.toLowerCase() === BILLING.toLowerCase()) };
};

const getAddressByType = (addresses, type) => addresses.find(({ addressType }) => addressType.toLowerCase() === type.toLowerCase());
const mapHeader = (type) => {
  switch (type) {
    case 'billing':
      return BILLING_HEADER;
    case 'visiting':
      return DELIVERY;
    case 'legal':
      return LEGAL;
    default:
      return '';
  }
};

svs.ticket_partner.companyDetails.utils = {
  createUpdateCompanyCustomerRequest,
  getAddressByType,
  mapHeader
};


 })(window);